import { render, staticRenderFns } from "./DeleteExpenseModal.vue?vue&type=template&id=6296181c&scoped=true&class=fill-height&"
import script from "./DeleteExpenseModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteExpenseModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteExpenseModal.vue?vue&type=style&index=0&id=6296181c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6296181c",
  null
  
)

export default component.exports